import Vue from "vue";
import Vuex from "vuex";

import authentication from "./module.authentication";
import config from "./module.config";
import stores from "./module.stores";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authentication,
    config,
    stores
  },
  state: {},
  mutations: {},
  actions: {}
});

export default store;
